module.exports = __webpack_public_path__ + "img/noData.a2a3e7b4.png";